<template>
  <div>
    <van-cell v-for="(item,index) in list" :key="index" @click="toDetails(item)">
      <div class="flex-between">
        <div>
          <div class="custName-wrap">
            <div class="custName">
              <van-icon name="bookmark" color="green" /> {{ item.custName }}
                 <!-- <van-tag style="margin-right:5px" type="primary" v-if="item.custName">{{item.custName}}</van-tag>             -->
            </div>
          </div>
          <div>
            <van-tag color="#c1c1c1" style="margin-right:5px" plain type="primary" v-if="item.businessTypeName">{{ item.businessTypeName }}</van-tag>
            <van-tag color="#c1c1c1" style="margin-right:5px" plain type="primary" v-if="item.boSource">{{ formatHandel("boSource",item.boSource) }}</van-tag>
            <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain type="primary" v-if="item.boStatus">{{ formatHandel("boStatus",item.boStatus) }}</van-tag> -->
            <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain type="primary" v-if="item.distributeStatus">{{ formatHandel("distributeStatus",item.distributeStatus) }}</van-tag> -->
          </div>
          <div>
            <span style="color: #ccc; font-size: 12px">跟进：{{item.userName}} 创建时间：{{ item.createTime }}</span>
          </div>
        </div>
            <van-icon color="#c1c1c1" name="arrow" size="16" class="arrow-color" />
      </div>
    </van-cell>
  </div>
</template>

<script>
import moment from 'moment'
import { Cell, Tag, Button, Icon } from 'vant'
import { getSourceTree } from '@/api/scrm/mycust'
export default {
  name: 'ListItem',
  components: {
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  data() {
    return {
      list: this.listData,
      dictOptions: {
        boSourceOptions: []
      },
      washResultOptions: []
    }
  },
  watch: {
    listData: function (newVal, oldVal) {
      this.list = newVal
    }
  },
  props: ['listData'],
  created() {
    if (this.dictOptions.boSourceOptions.length == 0) {
      getSourceTree().then(res => {
        this.dictOptions.boSourceOptions = res.rows.map(item => { return { dictLabel: item.custSourceName, dictValue: item.custSourceId } })
      })
    }
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    },
    timeFormat2(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    toDetails(item) {
      this.$emit('todetail', item)
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.dictOptions[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.custname{
  font-size: 0.35rem;
  color: #666;
}
</style>
